import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Toast } from 'primeng/toast';

/**
 * Shell. Holds the app's single `<p-toast>` so notifications survive route
 * changes and work on the routes outside the admin layout (login / error).
 */
@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, Toast],
    template: `
        <router-outlet></router-outlet>
        <p-toast />
    `,
})
export class AppComponent {}
